import { DashboardPage } from "./pages/dashboard-page";
import { DateProvider } from "./contexts/date-context";
import { AppDataProvider } from "./contexts/app-data-context";
import { ToastProvider } from "./components/ui/toast";

export function App() {
  return (
    <ToastProvider>
      <DateProvider>
        <AppDataProvider>
          <DashboardPage />
        </AppDataProvider>
      </DateProvider>
    </ToastProvider>
  );
}
